// extracted by mini-css-extract-plugin
module.exports = {"sentinel":"useInfiniteReveal_sentinel__3NHpe","sentinelRow":"useInfiniteReveal_sentinelRow__1U5u-"};